import {PaymentsRepository} from '../repository/PaymentsRepository';
import {Payment, PaymentFilterParams} from '../models/Payment';
import {Pagination} from '../../../Data/types/BaseResponse';

export class GetPaymentsWithFiltersUseCase {
  constructor (private paymentsRepository: PaymentsRepository) {}

  async execute (params: PaymentFilterParams): Promise<{ items: Payment[]; pagination?: Pagination }> {
    return this.paymentsRepository.getPaymentsWithFilters(params);
  }
}
